module.exports = __webpack_public_path__ + "img/Group 12431.90d46c35.png";